var BASE_URL = '/api'

export default {
  PAGESIZE: 5,
  TEST: BASE_URL + '/devices',
  LOGIN: BASE_URL + '/login',
  DASHBOARD: BASE_URL + '/dashboard',
  WRITE: BASE_URL + '/write',
  DELETE: BASE_URL + '/write',
  REQ_CONTENTS: BASE_URL + '/req_contents',
  REQ_LIST: BASE_URL + '/req_list',
  FETCH_USER_INFO: BASE_URL + '/users',
  UPDATE_USER_INFO: BASE_URL + '/users',
  FETCH_DEVICES: BASE_URL + '/devices',
  DELETE_DEVICE: BASE_URL + '/devices/${no}',
  FETCH_DEVICE_ONE: BASE_URL + '/devices/${no}',
  ADD: BASE_URL + '/devices',
  UPDATE_DEVICE: BASE_URL + '/devices/${no}',

  FETCH: BASE_URL + '/contacts_long',
  FETCH_ONE: BASE_URL + '/contacts/${no}',
  FETCH_MENU_RANKING: BASE_URL + '/diets/rank',
  FETCH_MENU_LIST: BASE_URL + '/diets/device/${no}',
  //UPDATE_PHOTO: BASE_URL + '/contacts/${no}/photo',
  UPLOAD_PHOTO: BASE_URL + '/uploadPhoto',
  DELETE_PHOTO: BASE_URL + '/deletePhoto',
  FETCH_ALL_MENU : BASE_URL + '/diets',
  FETCH_ALL_MENU_D : BASE_URL + '/diets',
  UPDATE_MENU : BASE_URL + '/diets/device/${no}',
  FETCH_DASHBOARD_PAGE: BASE_URL + '/home',
  FETCH_TOTALDETAIL: BASE_URL + '/home/detail',
  FETCH_TOTALDETAIL_PREVIEW: BASE_URL + '/home/detail_preview'


}



// WEBPACK FOOTER //
// ./src/Config.js